import React from 'react';

const COLORS = {
  primary: 'text-primary-600 hover:text-primary-800',
  green: 'text-green-600 hover:text-green-800',
  purple: 'text-purple-600 hover:text-purple-800',
  red: 'text-red-600 hover:text-red-800',
  yellow: 'text-amber-600 hover:text-amber-800',
  gray: 'text-gray-500 hover:text-gray-800',
  ghost: 'text-gray-500 hover:text-primary-700',
};

/**
 * Icon-only action button with a small tooltip that appears on hover/focus.
 * Used wherever a row of labeled buttons (Edit, Delete, + Category, ...) was
 * previously crowding the UI with icon+text pairs.
 */
export default function IconButton({ icon, label, onClick, color = 'primary', className = '', tooltipPosition = 'top' }) {
  const positionClasses = tooltipPosition === 'bottom'
    ? 'top-full mt-2'
    : 'bottom-full mb-2';

  return (
    <div className="relative inline-flex group">
      <button
        type="button"
        onClick={onClick}
        aria-label={label}
        className={`inline-flex items-center justify-center transition-colors ${COLORS[color] || COLORS.primary} ${className}`}
      >
        {icon}
      </button>
      <span
        role="tooltip"
        className={`pointer-events-none absolute ${positionClasses} left-1/2 -translate-x-1/2 whitespace-nowrap px-2 py-1 rounded-md bg-gray-900 text-white text-xs font-medium opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 group-focus-within:opacity-100 transition duration-150 z-20`}
      >
        {label}
      </span>
    </div>
  );
}
